import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import PersonalIdForm2 from "./PersonalIdForm2"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"
import { parseDate } from "../../Helper"
import { API } from "../../API"


class PersonalId2 extends React.Component {
  state = {
    identification_document_number: this.props.user
      .identification_document_number,
    id_document_type:
      this.props.user.id_document_type || "Identification Document",
    id_document_expiry: parseDate(this.props.user.id_document_expiry),
    identification_url: this.props.user.identification_url,
    identification_filename: this.props.user.identification_filename,
    issuing_place: this.props.user.issuing_place,
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleDateChange = (date) => {
    this.setState({ id_document_expiry: date })
  }

  handleRadioChange = (e) => {
    if(this.props.user.id_document_type===e.target.title)
    {
      this.setState({identification_document_number: this.props.user
            .identification_document_number,
        id_document_expiry: parseDate(this.props.user.id_document_expiry),
        identification_url: this.props.user.identification_url,
        identification_filename: this.props.user.identification_filename,
        issuing_place: this.props.user.issuing_place,})
    }
    else {
      this.setState({identification_document_number: "",
        id_document_expiry: null,
        identification_url: null,
        identification_filename: null,
        issuing_place: null})
    }
    this.setState({ id_document_type: e.target.title })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = [
      "drivers_license",
      "passport",
      "identification_document_number",
      "issuing_place",
      "id_document_expiry",
      "identification",
    ]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break;
      }
    }

    if (errors) {
      notify.hide();
      notify.show("Please complete the missing fields.")
      errors = true
    }

    if (!errors) {
      // Email notification
      API.sendTeacherProfileProgressEmail({
        _id: this.props.user._id,
        to: this.props.user.email,
        first_name: this.props.user.first_name,
        etype: "ID_CONF",
      }).then((result) => {
          console.log('result:', result)
        })
        .catch((err) => {
          console.log('err:', err)
        })
    }

    if (!errors) {
      this.props.updatePersonalDetails({ ...this.state })
    }
  }

  getTabs = () => {
    const tabs = [
      {
        pathname: "/personalid",
        text: "Personal ID",
        active: true,
      },
      {
        pathname: "/visa",
        text: "Visa Details",
      },
      {
        pathname: "/policecheck",
        text: "Police Check (Opt.)",
      },
      {
        pathname: "/wwcc",
        text: "WWCC (Optional)",
      },
      {
        pathname: "/usiCheck",
        text: "USI Check (Opt.)",
      }
    ]

    if (this.props.user?.is_elt) {
      tabs.push({
        pathname: "/uploadPayLevel",
        text: "Pay Level Evidence",
      })
    }

    if (this.props.user?.is_childhood_teacher) {
      tabs.push({
        pathname: "/ececcheck",
        text: "First AID",
      })
    }

    return tabs
  }

  tabs = this.getTabs()

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Identification"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <PersonalIdForm2
            handleFormFieldChange={this.handleFormFieldChange}
            handleStateChange={this.handleStateChange}
            handleDateChange={this.handleDateChange}
            handleRadioChange={this.handleRadioChange}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PersonalId2)
